export default __webpack_public_path__ + "static/media/logo.87c8c107.png";